import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { GET } from '../../../../core/_request'
import { useAuth } from '../../../../../auth'
import { paymentSchemesFieldMapping } from './fieldMapping'
import DetailSection from './PaymentSchemeDetailSection'
import { KTCardBody } from '../../../../../../../general/helpers'
import { PageTitle } from '../../../../../../../general/layout/core'
import { getBreadcrumbs } from '../../../../../../routing/Breadcrumbs'
import { useIntl } from 'react-intl'

export default function PaymentSchemeDetails() {
    const { id } = useParams()
    const { auth } = useAuth()
    const [details, setDetails] = useState<any>()
    const [labels, setLabels] = useState<{
        [name: string]: string
    }>({})
    const [detailsLoader, setDetailsLoader] = useState<boolean>()
    const intl = useIntl()

    function fetchAllLabels(obj: any) {
        const result = {}
        function recurse(current, path) {
            for (const key in current) {
                const newPath = path ? `${path}.${key}` : key
                if (typeof current[key] === 'object') {
                    recurse(current[key], newPath)
                } else {
                    result[newPath] = current[key]
                }
            }
        }
        recurse(obj, '')
        return result
    }

    useEffect(() => {
        const detailsAPI = `payments/schemes/${id}/details`
        const labelsAPI = `payments/schemes/labels`
        setDetailsLoader(true)
        GET(labelsAPI, auth?.accessToken ?? '').then((res) => {
            const { data } = res
            // Assuming labels response structure matches payment labels
            let tempLabels: any = data?.[0]?.['labels'] ?? data?.['labels'] ?? data?.[0] ?? data
            setLabels(fetchAllLabels(tempLabels))
        })
        GET(detailsAPI, auth?.accessToken ?? '').then((res) => {
            const { data } = res
            // backend returns { paymentScheme: ... }
            setDetails(data?.paymentScheme ?? data)
            setDetailsLoader(false)
        })
        //eslint-disable-next-line
    }, [])

    return (
        <>
            <PageTitle breadcrumbs={getBreadcrumbs(intl, 'viewPaymentScheme')}>
                {intl.formatMessage({ id: 'PAYMENT.SCHEME.DETAILS' })}
            </PageTitle>
            <KTCardBody>
                <div className='row'>
                    {Object.keys(paymentSchemesFieldMapping).map((section: string, index: number) => {
                        return (
                            <div
                                className='col-sm-12 col-xs-12 col-md-6 col-lg-6 mb-10 '
                                key={`${index}-section`}
                            >
                                <DetailSection
                                    details={details}
                                    title={section}
                                    fields={paymentSchemesFieldMapping[section]}
                                    labels={labels}
                                    detailsLoader={detailsLoader}
                                />
                            </div>
                        )
                    })}
                </div>
            </KTCardBody>
        </>
    )
}
